import React from 'react';
import { observer } from 'mobx-react';

const wrapInContainer = (ComponentToWrap, propsMapper) => {
  const canWrapComponentIntoObserver =
    (typeof ComponentToWrap === 'object' && ComponentToWrap.$$typeof === 'Symbol(react.memo)')
    || (typeof ComponentToWrap === 'function'
      && (!ComponentToWrap.prototype.isReactComponent || !ComponentToWrap.prototype.shouldComponentUpdate)
    );
  const Component = canWrapComponentIntoObserver ? observer(ComponentToWrap) : ComponentToWrap;
  return observer(props => (
    <Component {...propsMapper(props)} />
  ));
};

export default wrapInContainer;
